import React from "react";
import { Dialog, Heading, Text } from "@chakra-ui/react";

const networkName = (id: number | undefined): string => {
  switch (Number(id)) {
    case 1:
      return "Mainnet";
    case 3:
      return "Ropsten";
    case 4:
      return "Rinkeby";
    case 5:
      return "Goerli";
    case 6:
      return "Kotti";
    case 42:
      return "Kovan";
    case 61:
      return "Ethereum Classic - Mainnet";
    case 11297108099:
      return "Palm (TestNet)";
    case 11297108109:
      return "Palm";
    default:
      return "Other";
  }
};

interface INetworkUnsupportedModalProps {
  open: boolean;
  network: number | undefined;
  supportedNetworks: number[];
}

const NetworkUnsupportedModal: React.FC<INetworkUnsupportedModalProps> = ({
  open,
  network,
  supportedNetworks,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={() => null}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content p="32px" borderRadius="0px">
          <Dialog.Header p="0px" mb="40px">
            <Heading fontSize="24px"> Network Unsupported</Heading>
          </Dialog.Header>
          <Dialog.Body p="0px">
            <Text>
              This app does not currently support transfers on{" "}
              {networkName(network)}. Please change networks from within your
              browser wallet.
            </Text>
            <br />
            <Text>
              This app is configured to work on{" "}
              {supportedNetworks.map(
                (n, i) =>
                  `${networkName(n)}${
                    i < supportedNetworks.length - 1 ? ", " : ""
                  }`
              )}{" "}
              networks
            </Text>
          </Dialog.Body>
          <Dialog.Footer />
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default NetworkUnsupportedModal;
